{
    "LicenceManagementPage_Title": "Lizenzmanagement",
    "LicenceManagementPage_Subtitle": "Geräte- und Benutzerzuweisungen für einen ausgewählten Telefoniebereich verwalten.",
    "LicenceManagementPage_Tile_Analytics": "CX-Analyse",
    "LicenceManagementPage_Tile_Score": "CX-Score",
    "LicenceManagementPage_Tile_Record": "CX-Datensatz",
    "LicenceManagementPage_Tile_Integration": "CX-Integration",
    "LicenceManagementPage_Tile_Licences": "Lizenzen",
    "LicenceManagementPage_Column_DeviceNumber": "Gerät",
    "LicenceManagementPage_Column_Username": "Benutzername",
    "LicenceManagementPage_Column_Email": "E-Mail",
    "LicenceManagementPage_Column_HasDevice": "Gerät",
    "LicenceManagementPage_Column_Agent": "Agent",
    "LicenceManagementPage_Column_WelcomeEmail": "Willkommens-E-Mail",
    "LicenceManagementPage_Column_Licences": "Lizenzen",
    "LicenceManagementPage_Column_Actions": "Aktionen",
    "LicenceManagementPage_Type_Device": "Gerät",
    "LicenceManagementPage_Type_User": "Benutzer",
    "LicenceManagementPage_Popup_TelSys": "Telefonieserver",
    "LicenceManagementPage_Popup_Partition": "Partition",
    "LicenceManagementPage_Popup_Device": "Gerät",
    "LicenceManagementPage_Popup_Username": "Benutzername",
    "LicenceManagementPage_Popup_Email": "E-Mail",
    "LicenceManagementPage_Popup_Close": "Schließen",
    "LicenceManagementPage_LicencePopup_Title": "Produktlizenzen verwalten",
    "LicenceManagementPage_LicencePopup_Licence": "Lizenz",
    "LicenceManagementPage_LicencePopup_ScoreUserCalls": "Anrufe von Nutzern bewerten",
    "LicenceManagementPage_LicencePopup_RecordUserCalls": "Benutzeranrufe aufzeichnen",
    "LicenceManagementPage_LicencePopup_IntegrationEnabled": "Ermöglicht",
    "LicenceManagementPage_LicencePopup_On": "An",
    "LicenceManagementPage_LicencePopup_Off": "Aus",
    "LicenceManagementPage_LicencePopup_Enabled": "Ermöglicht",
    "LicenceManagementPage_LicencePopup_Disabled": "Deaktiviert",
    "LicenceManagementPage_LicencePopup_EmailRequired": "Fügen Sie eine E-Mail-Adresse hinzu, bevor Sie die Lizenzänderungen für dieses Gerät speichern.",
    "LicenceManagementPage_Email_AddTooltip": "Klicken Sie hier, um eine E-Mail-Adresse hinzuzufügen und einen Benutzer zu erstellen.",
    "LicenceManagementPage_EssentialsExtension": "Grundlagen (Erweiterung)",
    "LicenceManagementPage_Empty": "Hier wurde nichts gefunden.",
    "LicenceManagementPage_WelcomeEmail_Title": "Willkommens-E-Mail erneut senden an \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Confirm": "Möchten Sie die Willkommens-E-Mail an \"{}\" erneut senden?",
    "LicenceManagementPage_WelcomeEmail_Success": "Die E-Mail wurde erfolgreich an \"{}\" gesendet.",
    "LicenceManagementPage_WelcomeEmail_Fail": "Beim Senden der E-Mail ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "LicenceManagementPage_Licence_SaveFailed": "Die aktuellen Benutzereinstellungen konnten nicht gelesen werden, daher wurden die Lizenzen nicht gespeichert. Bitte versuchen Sie es erneut.",
    "LicenceManagementPage_Column_LicencesCount": "[{} Lizenzen]",
    "LicenceManagementPage_Tick_Save": "Zeilenänderungen speichern",
    "LicenceManagementPage_Tick_InvalidEmail": "Geben Sie eine gültige E-Mail-Adresse ein, um den Benutzer zu erstellen.",
    "LicenceManagementPage_Licence_ScoringEnabled": "Punktevergabe aktiviert",
    "LicenceManagementPage_Licence_RecordingEnabled": "Aufnahme aktiviert",
    "LicenceManagementPage_Licence_WithScoring": "{} + Punktevergabe",
    "LicenceManagementPage_Licence_WithRecording": "{} + Aufnahme",
    "LicenceManagementPage_Username_NoUserTooltip": "Dieser Wert wird als Benutzername verwendet, wenn ein neuer Benutzer erstellt wird.",
    "NAME": "Lizenzverwaltungsseite Sprache"
}